import React, {useState, useEffect} from 'react';
import { KompisCountdownBanner } from '@inter-ikea-kompis/react-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import styled from 'styled-components';

const CountdownWrapper = styled.div`
  z-index: 2000;
  position: fixed;
  top: 0;
`;

const CountdownBanner = ({experienceGalleryBackURL, cwtTranslation, idleTime}) => {
	const getQuery = (customSearch) => {
		return new URLSearchParams(customSearch ? customSearch : window.location.search);
	};
	
	const localizedInformation = {
		translations: {
			countdownBannerHeader: cwtTranslation["common.kompis.countdownBannerHeader"],
			countdownBannerGalleryButton: cwtTranslation["common.kompis.countdownBannerGalleryButton"], 
			buttonContinue: cwtTranslation["common.kompis.buttonContinue"]
		}
	}
	
	const defaultCountdownTime = 90; //for the countdown circle
	const countdownTimeout = defaultCountdownTime;
	const defaultIdleTime = 60; // it sets the banner active after 60 inactive seconds
	const idleTimeTimeout = (idleTime !== null && !isNaN(idleTime)) ? idleTime : defaultIdleTime;

	const [idleTimer, setIdleTimer] = useState(idleTimeTimeout);
	const [active, setActive] = useState(false);
	const [seconds, setSeconds] = useState(countdownTimeout);
	
    // After 60 sec of inactivity the countdownBanner should start
	useEffect(() => {
		const interval = setInterval(() => {

			if (idleTimer > 0) {
				setIdleTimer(idleTimer - 1);
			}
		}, 1000);

		if (idleTimer === 0) {
			setActive(true);
		}

		const resetTimeout = () => {
			setIdleTimer(idleTimeTimeout);
		};

		const events = ['mousemove', 'mousedown', 'scroll', 'keypress'];

		for (let i in events) {
			window.addEventListener(events[i], resetTimeout);
		}
		return () => {
			clearInterval(interval);
			for (let i in events) {
				window.removeEventListener(events[i], resetTimeout);
			}
		};
	}, [idleTimeTimeout, idleTimer]);

	// The countdown in the banner is 90 sec long, if the user does not do anything, user is redirected to the IPEX Gallery
	useEffect(() => {
		let interval = null;
		if (active) {
			interval = setInterval(() => {
				setSeconds(seconds => seconds - 1);
			}, 1000);
		} else if (!active && seconds !== 0) {
			clearInterval(interval);
		}
		return () => clearInterval(interval);
	}, [active, seconds]);

	const resetBannerCountdown = () => {
		setSeconds(countdownTimeout);
		setActive(false);
	};

	const onContinuePlanningSession = () => {
		resetBannerCountdown();
	};

	const backToIpexGallery = () => {
		resetBannerCountdown();
		window.location.href = experienceGalleryBackURL;
	};

	return (
		<CountdownWrapper>
			<KompisCountdownBanner
				onSessionClick={backToIpexGallery} 
				onClose={onContinuePlanningSession} //countdown banner will be closed and stay at planners page
				onTimeEnd={backToIpexGallery} 
				theme={SkapaTheme}
				localizedInformation={localizedInformation} //translations for countdown banner
				startTime={defaultCountdownTime} //planner fetch this from URL, ipex gallery passes a param "idleTime"
				time={seconds} //for countdown circle
				visible={active}
				id="countdownBanner"
				showSecondaryButton={true} />
		</CountdownWrapper>
	);
}

export default CountdownBanner;